import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke903aRequest, Sgke903aResponse, Sgke903aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke903aService {

  /**
   * コンストラクタ
   * @param service Sgke903aService
   * @param apiCommonService ApiCommonService
   * @param featuresLibConfig FeaturesLibConfig
   */
  constructor(
    public service: Sgke903aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /** SGKE903A_会社地区情報取得API呼出し */
  public doSgke903a(request: Sgke903aRequest): Observable<Sgke903aResponse> {

    return this.service.sgke903aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE903A');
          return throwError(err.message);
        })
      );
  }

}
